import { KeyboardEvent } from "react";

/** Arrow-key, Home and End navigation between [role="menuitem"] elements */
export const handleMenuKeys = (e: KeyboardEvent<HTMLElement>) => {
  const items = Array.from(
    e.currentTarget.querySelectorAll<HTMLElement>('[role="menuitem"]:not([disabled])')
  );
  if (!items.length) return;
  const i = items.indexOf(document.activeElement as HTMLElement);

  const move = (to: number) => {
    e.preventDefault();
    items[(to + items.length) % items.length]?.focus();
  };

  if (e.key === "ArrowDown") move(i + 1);
  else if (e.key === "ArrowUp") move(i - 1);
  else if (e.key === "Home") move(0);
  else if (e.key === "End") move(items.length - 1);
};
